const PEP = {
  title: 'Parceiro Padrão Zé',
  scoreboard: {
    title: 'Placar da sua loja',
    updatedAt: 'Atualizado em',
    viewHistory: 'ver histórico',
    sealsTooltip:
      'Quantidade de selos conquistados. Definem o seu nível e sua posição no ranking.',
  },
  history: {
    title: 'Histórico de selos',
    legend: {
      operational: 'Performance Operacional - Semanal',
      club: 'Missões Clube Zé+ - Mensal',
      quality: 'Jeito Zé de Qualidade - Trimestral',
    },
    categories: {
      operational: 'Performance Operacional',
      club: 'Missões Clube Zé+',
      quality: 'Qualidade Zé',
    },
  },
  challenges: {
    title: 'Pilares do programa - Resultados atuais',
    subtitle:
      'Mantenha seus indicadores para continuar com o resultado e melhore os pendentes para aumentar o número de selos',
    goalsLabel: 'Metas atingidas',
    forecastLabel: 'Previsão:',
    closesIn: 'Fecha em',
    viewDetails: 'Ver detalhes',
    hideDetails: 'Ocultar detalhes',
    sealsHelp:
      'A quantidade de selos ganhos por meta atingida ainda está sendo definida pelo time de Operações',
    context: {
      period: 'Período considerado',
      updatedAt: 'Última atualização',
      scoringRule: 'Regra de pontuação',
    },
    columns: {
      goalName: 'Nome da meta',
      missionName: 'Nome da missão',
      evaluationName: 'Nome da avaliação',
      currentIndicator: 'Indicador atual',
      current: 'Atual',
      partialTarget: 'Meta Parcial',
      target: 'Meta',
      status: 'Status',
    },
    detail: {
      question: 'Pergunta',
      indicator: 'Indicador',
      mission: 'Missão',
      metric: 'Métrica',
      goal: 'Meta',
      whyItMatters: 'Por que isso importa',
      howTo: 'Como fazer',
      accessLink: 'Acesse o link',
      openGoal: 'Ver detalhe',
    },
    guideDownload: {
      description: 'Acompanhe as regras e detalhes de cada avaliação',
      downloadLabel: 'Baixar documento',
    },
    pillars: {
      operational: {
        title: 'Incentivo Operacional',
        cadence: 'Semanal',
      },
      club: {
        title: 'Missões Clube Zé+',
        cadence: 'Mensal',
      },
      quality: {
        title: 'Guia Padrão Zé',
        cadence: 'Trimestral',
      },
    },
    status: {
      achieved: 'Atingida',
      notAchieved: 'Não atingida',
      partial: 'Parcial',
    },
  },
  prizes: {
    title: 'Confira os prêmios para os melhores do ranking!',
    downloadLabel: 'Baixar premiações',
    downloadAwardsText: 'Confira os prêmios para os melhores do ranking! ',
  },
  programTerms: {
    title: 'Termos do Programa',
    documents: {
      regulation: {
        title: 'Regulamento',
        description:
          'Determina os direitos e responsabilidades entre o Zé Delivery e o seu negócio.',
        downloadLabel: 'Baixar documento',
      },
    },
  },
}

export default PEP
